const Ru = {
  translation: {
    error: {
      doNotHaveAccessToViewThisModule: 'У вас нет доступа к просмотру данного модуля',
      dataEnteredIncorrectly: 'Данные введены некорректно',
      pleaseFillInTheHighlightedFields: 'Пожалуйста заполните выделенные поля',
      errorSavingReport: 'Ошибка при сохранении отчета',
    },
    main: {
      SCcontrolPanel: 'Панель управления СЦ',
      exit: 'Выход',
    },
    sideBar: {
      roadRepairPlans: 'План ремонта дорог',
      intersections: 'Пересечения',
      addRoadRepairPlan: 'Добавить план ремонта дорог',
      configuringUsers: 'Настройка пользователей',
      settingUpRoles: 'Настройка ролей',
      settingUpDirectories: 'Настройка справочников',
      makeSchedule: 'Составление расписания',
      userActions: 'Действия пользователей',
      updateData: 'Обновление данных',
      videoStreams: 'Видеопоток',
      healthCare: 'Здравоохранение',
    },
    roadRepairPlan: {
      allRoadRepairPlans: 'Все планы ремонта дорог',
      responsible: 'Ответственный',
      categoryOfWork: 'Категория работ',
      plot: 'Участок',
      street: 'Улица',
      contractor: 'Подрядчик',
      hiddenWork: 'Скрытая работа',
      start: 'Начало',
      end: 'Окончание',
      action: 'Действие',
      edit: 'Редактировать',
      delete: 'Удалить',

      search: 'Поиск',
      reset: 'Сбросить',
      exactlyWantToDelete: 'Точно хотите удалить',
      loadingPleaseWait: 'Загрузка, пожалуйста подождите',
      removed: 'Удалено',
      yes: 'Да',
      no: 'Нет',
    },
    intersections: {
      allIntersections: 'Все пересечения',
      act: 'Действие',
      responsible: 'Ответственные',
      categoryOfWork: 'Категория работ',
      street: 'Улица',
      contractor: 'Подрядчик ',
      action: 'Действие',
      delete: 'Удалить',
      edit: 'Редактировать',

      exactlyWantToDelete: 'Вы точно хотите удалить отчет от',
      loadingPleaseWait: 'Загрузка, пожалуйста подождите',
      removed: 'Удалено',
      obligatoryField: 'Обязательное поле',
    },
    addRoadRepairPlan: {
      addingNewRoadRepairPlan: 'Добавление нового плана ремонта дорог',
      crossing: 'Пересечение',
      chooseTheResponsible: 'Выберите ответственного',
      selectCategoryOfWork: 'Выберите категорию работ ',
      replacingTheWaterSupply: 'Замена водопровода ',
      overhaulOfRoads: 'Капитальный ремонт дорог ',
      pipeReconstruction: 'Реконструкция трубы ',
      mediumRoadRepair: 'Средний ремонт дорог ',
      roadMaintenance: 'Текущий ремонт дорог ',
      overlappingTheStreet: 'Перекрытие улицы ',
      objectTypeOnTheMap: 'Тип объекта на карте ',
      coordinates: 'Координаты ',
      label: 'Метка',
      polygon: 'Полигон',
      dateOfThePlannedStartOfWork: 'Дата планируемого начала работ',
      beginningOfWork: 'Начало работ',
      incompleteDateOfThePlannedStartOfWork: 'Не полная дата планируемого начала работ',
      plannedCompletionDate: 'Дата планируемого окончания работ',
      completionOfWork: 'Окончание работ',
      incompleteDateOfThePlannedCompletionOfWork: 'Не полная дата планируемого окончания работ',
      chooseContractor: 'Выберите подрядчика',
      responsibleRepairContacts: 'Контакты ответственного исполнения ремонта',
      selectRepairExecutionStatus: 'Выберите состояние исполнения ремонта',
      inWork: 'В работе',
      performed: 'Выполнено ',
      scheduledRepairs: 'Запланированный ремонт',
      projectCost: 'Стоимость проекта',
      theAmountPlannedFor2021: 'Сумма запланированная на 2021 г.',
      hideThisRoadRepairPlan: 'Скрыть этот план ремонта дорог',
      addTo: 'Добавить',
      yes: 'Да',
      no: 'Нет',
      responsible: 'Ответственный',
      street: 'Улица',
      plot: 'Участок',
      selectCategory: 'Выберите категорию',
      openingOfTheRoadway: 'Вскрытие дорожного полотна',
      warrantyPeriod: 'Гарантийный период',
      length: 'Протяженность',
      whoAcceptedTheWork: 'Кто принял работы',
      comments: 'Комментарии',

      addedBy: 'Добавлено',
      pleaseFillInTheHighlightedFields: 'Пожалуйста заполните выделенные поля',
      loadingPleaseWait: 'Загрузка, пожалуйста подождите',
      pleaseChooseResponsible: 'Пожалуйста выберите ответственного',
      pleaseEnterTheStreet: 'Пожалуйста введите улицу',
      pleaseSelectCategory: 'Пожалуйста выберите категорию',
      selectRoadPlans: 'Выберите планы дорог',
    },
    configuringUsers: {
      allUsers: 'Все пользователи',
      addUser: 'Добавить пользователя',
      fullName: 'ФИО',
      login: 'Логин',
      role: 'Роль',
      action: 'Действие',
      edit: 'Редактировать',
      delete: 'Удалить',
      password: 'Пароль',
      changeUser: 'Изменить пользователя',
      phoneNumber: 'Номер телефона',
      roles: 'Роли',
      addingNewUser: 'Добавление нового пользователя',
      email: 'Электронная почта',
      savedBy: 'Сохранено',
      thisUserAlreadyExistsPleaseEnterAnother: 'Такой пользователь уже существует, введите другой',
      pleaseFillInAllFields: 'Пожалуйста заполните все поля',
      user: 'Пользователь',
      established: 'создан',
      removed: 'Удалено',
      loadingPleaseWait: 'Загрузка, пожалуйста подождите',
      regions: 'Регионы',
      region: 'Регион',
      editUser: 'Редактировать пользователя',
    },
    settingUpRoles: {
      allRoles: 'Все роли',
      add: 'Добавить',
      delete: 'Удалить',
      changeCase: 'Изменить модуль',
      addRole: 'Добавить роль',
      code: 'Код',
      description: 'Описание',
      case: 'Модуль',
      action: 'Действие',
      edit: 'Редактировать',
      changingRoles: 'Изменение ролей',

      savedBy: 'Сохранено',
      thisUserAlreadyExistsPleaseEnterAnother: 'Такой пользователь уже существует, введите другой',
      pleaseFillInAllFields: 'Пожалуйста заполните все поля',
      loadingPleaseWait: 'Загрузка, пожалуйста подождите',
      addedBy: 'Добавлено',
    },
    settingUpDirectories: {
      categoryReference: 'Справочник категории',
      contractorsDirectory: 'Справочник подрядчиков',
      name: 'Название',
      responsibleDirectory: 'Справочник ответственных',
      delete: 'Удалить',

      addedBy: 'Добавлено',
      exactlyWantToDelete: 'Точно хотите удалить',
      yes: 'Да',
      no: 'Нет',
      enterNewCategory: 'Введите новую категорию',
      addTo: 'Добавить',
      enterResponsible: 'Введите ответственного',
      removed: 'Удалено',
      plus: 'Добавить',
    },
    settingSchedule: {
      locality: 'Населенный пункт',
      distance: 'Расстояние',
      speed: 'Скорость',
      parking: 'Стоянка',
      arrival: 'Прибытие',
      departure: 'Отправление',
      movementTime: 'Время движения',
      directDirection: 'Прямое направление',
      reverseDirection: 'Обратное направление',
    },
    userActions: {
      eventView: 'Просмотр',
      eventCreate: 'Создание',
      eventUpdate: 'Редактирование',
      eventDelete: 'Удаление',
      eventOpenCase: 'Открытие модуля',
      serviceName: 'Наименование услуг',
      serviceCode: 'Код услуги',
      organization: 'Организация',
      modelOrganization: 'Модель',
      chapter: 'Раздел',
      category: 'Категория',
      subcategory: 'Подкатегория',
      reportTitle: 'Тип отчета',
      region: 'Район',
      year: 'Год',
      month: 'Месяц',
      login: 'Логин',
      dateTime: 'Дата',
      action: 'Действие',
      object: 'Объект',
      caseName: 'Название модуля',
      startDate: 'Начало',
      endDate: 'Конец',
      reset: 'Сбросить',
      choose: 'Выбрать',
    },
    chartStatus: {
      year: 'Год',
      search: 'Найти',
      reset: 'Сбросить',
      organization: 'Организация',
      modelOrganization: 'Модель',
      reportTitle: 'Наименование отчёта',
    },
    gosServiceList: {
      serviceList: 'Реестр услуг',
      eventList: 'Реестр мероприятий',
      charts: 'Отчеты',
      createChart: 'Создать отчет',
      chartStatus: 'Статус отчетов',
      successSavingReport: 'Отчет успешно сохранен',
    },
    health: {
      pageTitle: 'Здравоохранение',
      subtitle: 'Автоматизированное рабочее место · ведение план/факт по показателям и периодам',
      create: 'Создать',
      fltPeriod: 'Период:',
      fltIndicator: 'Показатель:',
      allPeriods: 'Все периоды',
      allIndicators: 'Все показатели',
      colInd: 'Показатель',
      colPeriod: 'Период',
      colPlan: 'План',
      colFact: 'Факт',
      shown: 'Показано записей:',
      of: 'из',
      mTitle: 'Внесение показателя здравоохранения',
      fIndicator: 'Показатель',
      fType: 'Тип периода',
      fYear: 'Год',
      fQuarter: 'Квартал',
      fUnit: 'Единица измерения',
      fPlan: 'Плановое значение',
      fFact: 'Фактическое значение',
      fDir: 'Направление оценки',
      fNote: 'Примечание',
      grpPeriod: 'Отчётный период',
      year: 'Год',
      quarter: 'Квартал',
      choose: '— выберите —',
      autoFill: 'заполнится по показателю',
      phNote: 'Пояснение к внесённым значениям (необязательно)',
      optional: 'Необязательное поле.',
      dirLowerBetter: 'ниже плана — лучше',
      dirHigherBetter: 'выше плана — лучше',
      hintIndicator:
        'Из справочника показателей здравоохранения. Определяет наименование и — автоматически — единицу измерения и направление оценки.',
      hintType:
        'Значение справочника: «Год» → period_type=Жыл (квартал не задаётся); «Квартал» → period_type=Квартал с номером квартала.',
      hintUnit:
        'Заполняется автоматически из справочника показателей. Только отображение, на расчёт не влияет.',
      hintDir:
        'Заполняется автоматически из справочника: «ниже плана — лучше» либо «выше плана — лучше». Определяет расчёт статуса в основной части.',
      hintPlan: 'Числовое (10,2), ≥ 0. Допускается 0. Хранится и сравнивается как есть.',
      hintFact: 'Числовое (10,2), ≥ 0. Статус выполнения рассчитывает основная часть, не форма.',
      reqMsg: 'Поле обязательно для заполнения',
      numMsg: 'Число в формате (10,2), не меньше 0',
      dupMsg:
        'Запись по этому показателю за выбранный отчётный период уже существует. Повтор недопустим.',
      saveError: 'Не удалось сохранить показатель. Попробуйте ещё раз.',
      loadError: 'Не удалось загрузить данные',
      retry: 'Повторить',
      cancel: 'Отмена',
      save: 'Сохранить',
      empty: 'Нет записей по заданным фильтрам',
      toastOk: 'Показатель сохранён',
      toastSub: 'Запись добавлена в перечень и в журнал действий пользователей',
      lblYear: 'год',
      lblQuarters: ['I квартал', 'II квартал', 'III квартал', 'IV квартал'],
      q1: 'I квартал',
      q2: 'II квартал',
      q3: 'III квартал',
      q4: 'IV квартал',
    },
    videoStreams: {
      title: 'Видеопоток',
      subtitle: 'Автоматизированное рабочее место · ведение перечня источников видеопотока',
      create: 'Создать',

      colSrc: 'Наименование источника',
      colAddr: 'Адрес видеопотока',
      colLoc: 'Местоположение',
      colFile: 'Видеофайл',
      colPlan: 'Плановый срок',
      colFact: 'Фактический срок',
      emptyTitle: 'Записей нет',
      emptyText:
        'В перечень ещё не внесено ни одного источника видеопотока. Нажмите «Создать», чтобы добавить первый.',
      errLoad: 'Не удалось загрузить перечень источников видеопотока.',
      retry: 'Повторить',
      mTitle: 'Создание источника видеопотока',
      fSource: 'Наименование источника',
      fAddress: 'Адрес видеопотока',
      fLocation: 'Местоположение',
      fFile: 'Видеофайл',
      fPlan: 'Плановый срок выполнения работ',
      fFact: 'Фактический срок выполнения работ',
      phSource: 'Наименование камеры видеонаблюдения',
      phAddress: 'Адрес места установки камеры',
      phLocation: 'Местоположение камеры видеонаблюдения',
      hintLocation: 'Используется как разрез круговой диаграммы в основной части ПО.',
      hintFile:
        'Видеозапись, прикрепляемая к записи. Рекомендуемый формат — MP4 (H.264). Предельный размер уточнить у профильного отдела.',
      optional: 'Необязательное поле.',
      pick: 'Выберите файл',
      reqMsg: 'Поле обязательно для заполнения',
      reqMsgFile: 'Прикрепите видеофайл',
      cancel: 'Отмена',
      save: 'Сохранить',
      errSave: 'Не удалось сохранить источник. Попробуйте ещё раз.',
      errFile413: 'Файл превышает допустимый размер. Выберите файл меньшего объёма.',
      errFile415: 'Неподдерживаемый формат файла. Рекомендуется MP4 (H.264).',
      toastOk: 'Источник видеопотока сохранён',
      toastSub: 'Запись добавлена в перечень и в журнал действий пользователей.',
    },
    dataUpdate: {
      pageTitle: 'Обновление данных',
      filterPrefix: 'фильтр',
      filterResult: 'Результат',
      filterModule: 'Модуль / источник',
      filterPeriod: 'период',
      dateFrom: 'Обновлено с',
      dateTo: 'Обновлено по',
      reset: 'Сбросить фильтры',
      dateHint: 'При активном диапазоне дат модули без обновления (—) в выборку не попадают.',
      all: 'Все',
      success: 'Успешно',
      error: 'Ошибка',
      noData: 'Нет данных',
      colModule: 'Функциональный модуль',
      colSource: 'Информационная система – источник данных',
      colDate: 'Дата и время последнего обновления',
      colCount: 'Количество полученных записей',
      colResult: 'Результат',
      cntTotal: 'Модулей на обновлении',
      cntSuccess: 'Обновлено успешно',
      cntError: 'С ошибкой',
      cntNever: 'Не обновлялись',
      badgeUnification: 'унификация',
      legendSuccess: 'Успешно — последний сеанс завершён успешно',
      legendError: 'Ошибка — последний сеанс с ошибкой (данные сохранены с прошлого успешного)',
      legendNoData: 'Нет данных — обновление ещё не выполнялось',
      legendNote: 'Цвет обозначает итог сеанса загрузки, а не оценку достижения показателей.',
      empty: 'Нет записей по заданным фильтрам',
      loadError: 'Не удалось загрузить данные',
      retry: 'Повторить',
      dash: '—',
    },
  },
};

export default Ru;
